<!-- Admin -->
<div class="admin-page p-6 md:p-10 space-y-6 bg-primary-50">

  <!-- Page header -->
  <header class="flex items-center gap-4">
    <button type="button"
            (click)="home()"
            class="inline-flex items-center justify-center w-20 h-20 rounded-xl border border-primary-200 hover:bg-gray-50 focus:outline-none focus:ring"
            aria-label="Home">
      <i class="pi pi-home !text-5xl"></i>
    </button>

    <div class="flex-1">
      <h1 class="text-2xl md:text-3xl font-bold tracking-tight">Admin Functions</h1>
      <p class="text-sm text-gray-500">Tools for export, backup, and configuration</p>
    </div>
  </header>

  <!-- Actions grid -->
  <section class="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4">
    <!-- Download Notes -->
    <article class="group rounded-2xl border !bg-primary-100 border-gray-200 p-5 shadow-sm hover:shadow-md transition">
      <div class="flex items-start gap-3">
        <span class="inline-flex items-center justify-center w-10 h-10 rounded-xl bg-primary-200">
          <i class="pi pi-cloud-download text-emerald-600  !text-5xl"></i>
        </span>
        <div class="flex-1">
          <h2 class="font-semibold">Download All Notes (JSON)</h2>
          <p class="text-sm text-gray-500">Export a full data dump for backup or migration.</p>
        </div>
      </div>
      <div class="mt-4">
        <button type="button"
                (click)="downloadNotesDB()"
                class="px-3 py-2 rounded-lg bg-emerald-600 text-white hover:bg-emerald-700 focus:outline-none focus:ring !text-xl">
          Download JSON
        </button>
      </div>
    </article>

    <!-- Export PDF
    <article class="group rounded-2xl border !bg-primary-100 border-gray-200 p-5 shadow-sm hover:shadow-md transition">
      <div class="flex items-start gap-3">
        <span class="inline-flex items-center justify-center w-10 h-10 rounded-xl bg-rose-50">
          <i class="pi pi-file-pdf text-rose-600 !text-5xl"></i>
        </span>
        <div class="flex-1">
          <h2 class="font-semibold">Export to PDF</h2>
          <p class="text-sm text-gray-500">Generate a printable PDF from your notes.</p>
        </div>
      </div>
      <div class="mt-4">
        <button type="button"
                (click)="exportPDF()"
                class="px-3 py-2 rounded-lg bg-rose-600 text-white hover:bg-rose-700 focus:outline-none focus:ring">
          Export PDF
        </button>
      </div>
    </article> -->

    <!-- Backup (future) -->
    <article class="rounded-2xl border border-dashed border-gray-200 p-5 bg-gray-50">
      <div class="flex items-start gap-3 opacity-60">
        <span class="inline-flex items-center justify-center w-10 h-10 rounded-xl bg-gray-100">
          <i class="pi pi-warehouse text-gray-500 !text-5xl"></i>
        </span>
        <div class="flex-1">
          <h2 class="font-semibold">Server Backup</h2>
          <p class="text-sm text-gray-500">Planned feature. Will push encrypted backups to server.</p>
        </div>
      </div>
      <div class="mt-4">
        <button type="button"
                class="px-3 py-2 rounded-lg bg-gray-200 text-gray-600 cursor-not-allowed"
                disabled>
          Coming Soon
        </button>
      </div>
    </article>

    <!-- PrimeNG Test Area -->
    <article class="group rounded-2xl border !bg-primary-100 border-gray-200 p-5 shadow-sm hover:shadow-md transition">
      <div class="flex items-start gap-3">
        <span class="inline-flex items-center justify-center w-10 h-10 rounded-xl bg-blue-50">
          <i class="pi pi-sliders-h text-blue-600 !text-5xl"></i>
        </span>
        <div class="flex-1">
          <h2 class="font-semibold">PrimeNG Test Area</h2>
          <p class="text-sm text-gray-500">Playground for UI controls.</p>
        </div>
      </div>

      <div class="mt-4">
        <p-select
          [options]="countries"
          [(ngModel)]="selectedCountry"
          optionLabel="name"
          placeholder="Select a City"
          class="w-full md:w-64">
        </p-select>
      </div>
    </article>

    <!-- Manage Categories -->
    <article class="group rounded-2xl border border-gray-200 !bg-primary-100 p-5 shadow-sm hover:shadow-md transition">
      <div class="flex items-start gap-3">
        <span class="inline-flex items-center justify-center w-10 h-10 rounded-xl bg-indigo-50">
          <i class="pi pi-tags text-indigo-600 !text-5xl"></i>
        </span>
        <div class="flex-1">
          <h2 class="font-semibold">Manage Categories</h2>
          <p class="text-sm text-gray-500">Create, rename, and organize categories.</p>
        </div>
      </div>
      <div class="mt-4">
        <button type="button"
                (click)="goToEditCategories()"
                class="px-3 py-2 rounded-lg bg-indigo-600 text-white hover:bg-indigo-700 focus:outline-none focus:ring">
          Category Manager
        </button>
      </div>
    </article>

    <!-- Manage Tags -->
    <article class="group rounded-2xl border border-gray-200 !bg-primary-100 p-5 shadow-sm hover:shadow-md transition">
      <div class="flex items-start gap-3">
        <span class="inline-flex items-center justify-center w-10 h-10 rounded-xl bg-teal-50">
          <i class="pi pi-tag text-teal-600 !text-5xl"></i>
        </span>
        <div class="flex-1">
          <h2 class="font-semibold">Manage Tags</h2>
          <p class="text-sm text-gray-500">Edit, colorize, and remove tags.</p>
        </div>
      </div>
      <div class="mt-4">
        <button type="button"
                (click)="goToEditTags()"
                class="px-3 py-2 rounded-lg bg-teal-600 text-white hover:bg-teal-700 focus:outline-none focus:ring">
          Tag Manager
        </button>
      </div>
    </article>

    <!-- Manage Attachments -->
    <article class="group rounded-2xl border border-gray-200 !bg-primary-100 p-5 shadow-sm hover:shadow-md transition">
      <div class="flex items-start gap-3">
        <span class="inline-flex items-center justify-center w-10 h-10 rounded-xl bg-orange-50">
          <i class="pi pi-paperclip text-orange-600 !text-5xl"></i>
        </span>
        <div class="flex-1">
          <h2 class="font-semibold">Manage Attachments</h2>
          <p class="text-sm text-gray-500">View, download, rename, and delete attachments across all notes.</p>
        </div>
      </div>
      <div class="mt-4">
        <button type="button"
                (click)="goToManageAttachments()"
                class="px-3 py-2 rounded-lg bg-orange-600 text-white hover:bg-orange-700 focus:outline-none focus:ring">
          Attachment Manager
        </button>
      </div>
    </article>
  </section>

</div>
